import { useEffect, useState } from "react";

export const useDetectWhiteOverlay = () => {
  // Handles state for white overlay
  const [isOverlayDisplay, setIsOverlayDisplay] = useState(true);

  const setOverlayDisplayed = (mutationList: MutationRecord[]) => {
    for (const mutation of mutationList) {
      if (mutation.type !== "attributes") return;
      const target = mutation.target as HTMLElement;
      if (!target.classList.contains("nooverlay")) return;

      setIsOverlayDisplay(false);
    }
  };

  useEffect(() => {
    // Add mutation observer to detect changes if there a change in the overlay element
    if (typeof window === "undefined") return;

    const htmlElement = window.document.documentElement;

    if (!htmlElement) return;
    const observer = new MutationObserver(setOverlayDisplayed);
    observer.observe(htmlElement, {
      attributes: true,
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    // Add addtional check if the overlay is displayed
    if (typeof window === "undefined") return;

    const htmlElement = window.document.documentElement;

    if (!htmlElement) return;
    if (!htmlElement.classList.contains("nooverlay")) return;

    setIsOverlayDisplay(false);
  }, []);

  return { isOverlayDisplay };
};
